import { format } from "date-fns"
import utcToZonedTime from "date-fns-tz/utcToZonedTime"
import React from "react"
import CurrencyFormat from "react-currency-format"
import { getCampaignBudgetUIState } from "./sf_campaign_budgets_helper"
import { HOURS_OF_DAY_LABEL_VALUES } from "./sf_campaign_schedule_helper"
import { NAME_OF_PRODUCT_TYPES, SfFilterTypes, SfFilterRelationalOperators, getProductTypeByName, getLeadTypeByName, ADMIN_FEATURE_IDS, PIXEL_COLUMN_TABLE_FIELDS, BUDGETS_TYPES } from "./sf_constants"
import { ORDER_BY } from 'common/sf_strings'
import { getIANATimezoneStringForAbbreviation, forColumnHeaderWrapper, sortStringAsFloat, SfCommaStringFormatter, SfPercentStringFormatter, Sfdelimitter, dollarFormatWithTwoDecimalPlaces, percentFormatWithTwoDecimalPlaces, commaFormatWithTwoDecimalPlaces, compareBudgetTypes } from "./sf_utils"
import Skeleton from 'react-loading-skeleton'
import * as Formatters from 'pages/Admin/Users/UserComponents/UserList/Formatters'
import _ from "lodash"
import { emailRegex, invalidEmailRegex, STR_INVALID_EMAIL, STR_INVALID_EMAIL_DIGITS_ERROR } from "common/utils/data_validations"

export const getSummaryStringForDailyBudget = (campaign) => {
    let limit_type = "Not Set"
    let units = "Not Set"

    const campaignUIState = getCampaignBudgetUIState({
        campaign_budgets: campaign?.campaign_budgets || [],
        monthly_budget: campaign?.monthly_budget || '',
        monthly_volume: campaign?.monthly_volume || ''
    })

    if (!campaignUIState.daily_limit_type) {
        return units
    }
    switch (campaignUIState.daily_limit_type) {
        case 'undefined':
        case 'null':
            return 'Not Set'
        case 'Daily Budget':
            units = (!campaignUIState.daily_budget_units) ? 'Not Set' : (<CurrencyFormat value={campaignUIState.daily_budget_units} prefix="$" displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} />)
            return units
        case 'Daily Volume':
            units = (!campaignUIState.daily_budget_units) ? 'Not Set' : (<CurrencyFormat value={campaignUIState.daily_budget_units} suffix=" units" displayType={'text'} thousandSeparator={true} />)
            return units
        case 'Budget by Day':
        case 'Volume by Day':
            return 'Varies by Day'
        case 'Unlimited':
        case 'unlimited':
            return 'Unlimited'

    }
}

export const getSummaryStringForMonthlyBudget = (campaign) => {
    let limit_type = "Not Set"
    let units = "Not Set"

    const campaignUIState = getCampaignBudgetUIState({
        campaign_budgets: campaign?.campaign_budgets || [],
        monthly_budget: campaign?.monthly_budget || '',
        monthly_volume: campaign?.monthly_volume || ''
    })

    if (!campaignUIState.monthly_limit_type) {
        return units
    }
    switch (campaignUIState.monthly_limit_type) {
        case 'undefined':
        case 'null':
            return 'Not Set'
        case 'Monthly Budget':
            units = (!campaignUIState.monthly_budget_units) ? 'Not Set' : (<CurrencyFormat value={campaignUIState.monthly_budget_units} prefix="$" displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} />)
            return units
        case 'Monthly Volume':
            units = (!campaignUIState.monthly_budget_units) ? 'Not Set' : (<CurrencyFormat value={campaignUIState.monthly_budget_units} suffix=" units" displayType={'text'} thousandSeparator={true} />)
            return units
        case 'Unlimited':
        case 'unlimited':
            return 'Unlimited'

    }
}

export const getCampaignSpendToday = (campaign_spends, account_timezone) => {
    if (!campaign_spends?.length) {
        return 0
    }
    const date_today_in_account_timezone = format(utcToZonedTime(new Date(),
        getIANATimezoneStringForAbbreviation(account_timezone)), 'yyyy-MM-dd')
    campaign_spends = campaign_spends.filter(campaign_spend => campaign_spend.dt === date_today_in_account_timezone)
    const sum = campaign_spends.reduce((acc, campaign_spend) => {
        return acc + parseFloat(campaign_spend.dollar_amt)
    }, 0)
    return parseFloat(sum)
}

export const getCampaignSpendThisMonth = (campaign_spends, account_timezone) => {
    if (!campaign_spends?.length) {
        return 0
    }
    const this_month_in_account_timezone = format(utcToZonedTime(new Date(),
        getIANATimezoneStringForAbbreviation(account_timezone)), 'yyyy-MM')
    campaign_spends = campaign_spends.filter(campaign_spend => campaign_spend.dt.includes(this_month_in_account_timezone))
    const sum = campaign_spends.reduce((acc, campaign_spend) => {
        return acc + parseFloat(campaign_spend.dollar_amt)
    }, 0)
    return parseFloat(sum)
}

export const addNumbersSafely = (current, addition) => {
    const currentNum = Number(current) || 0;
    const additionNum = Number(addition) || 0;
    return currentNum + additionNum;
  };

export const getNumberOfHoursActivated = (campaignSchedule) => {

    let total_num_hours = 0
    campaignSchedule.map((schedule) => {
        if (schedule.active === true) {
            Object.keys(HOURS_OF_DAY_LABEL_VALUES).map(hour => {
                if (schedule[hour] > 0) {
                    total_num_hours += 1
                }
            }

            )
        }
    })
    return total_num_hours
}

export const getTrackingForCampaign = (campaign) => {
    if (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.CLICKS || campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS) {
        return campaign?.click_campaign_setting
    }

    if (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.LEADS) {
        return campaign?.lead_campaign_setting
    }

    if (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.CALLS) {
        return campaign?.call_campaign_setting
    }

    return null;
}

// Returns true if two lead_integrations lists differ on (id, config). Accepts either the
// outgoing form shape ({ value, config }) or the slice/campaign shape ({ id, config }).
// Used by tracking-section submits to decide whether to refetch campaign_attached_integrations.
export const didLeadIntegrationsChange = (a, b) => {
    const fingerprint = (list) => JSON.stringify(
        (list || [])
            .map(el => [el?.id ?? el?.value, el?.config ?? null])
            .sort((x, y) => (x[0] > y[0] ? 1 : -1))
    )
    return fingerprint(a) !== fingerprint(b)
}

/**
 * 
 * @param {integer} product_type_id  From current campaign
 * @param {integer} lead_type_id From current campaign
 * @param {string} is_a_level_filter From current campaign
 * @param {array} all_sf_filters From create campaing component/edit campaing component
 * @param {object} current_account From Current account
 * @returns 
 */
export const getSfFilterByProductAndLeadType = (product_type_id, lead_type_id, is_a_level_filter, all_sf_filters, current_account) => {
    let sf_filters = all_sf_filters.filter(fltr =>
        fltr.product_type_id === product_type_id &&
        fltr.lead_type_id === lead_type_id &&
        fltr[is_a_level_filter] &&
        fltr.active
    )
    if (!current_account?.enterprise && !current_account?.internal) {
        sf_filters = sf_filters.filter(fltr => fltr.retail)
    }

    return sf_filters;
}

export const getMetricNamesForPixelStats = (product_type_name, new_campaign_page_feature_flag_active) => {
    let conversions_count_type = null
    let analytics_leads_type = null
    let analytics_payout_type = null
    let conversions_revenue_type = null
    switch (product_type_name) {
        case NAME_OF_PRODUCT_TYPES.CLICKS:
        case NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS:
        case NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS:
            conversions_count_type = 'click_conversions_count'
            analytics_leads_type = new_campaign_page_feature_flag_active ? 'click_analytic_total_clicks' : 'click_analytic_clicks'
            analytics_payout_type = new_campaign_page_feature_flag_active ? 'click_analytic_total_cost' : 'click_analytic_total_payout'
            conversions_revenue_type = 'click_conversions_revenue'
            break;
        case NAME_OF_PRODUCT_TYPES.LEADS:
            conversions_count_type = 'lead_conversions_count'
            analytics_leads_type = 'lead_analytic_total_leads'
            analytics_payout_type = 'lead_analytic_total_cost'
            conversions_revenue_type = 'lead_conversions_revenue'
            break;
        case NAME_OF_PRODUCT_TYPES.CALLS:
            conversions_count_type = 'call_conversions_count'
            analytics_leads_type = new_campaign_page_feature_flag_active ? 'call_analytic_total_accepted' : 'call_analytic_billable_calls'
            analytics_payout_type = 'call_analytic_total_cost'
            conversions_revenue_type = 'call_conversions_revenue'
            break;
    }
    return [conversions_count_type, analytics_leads_type, analytics_payout_type, conversions_revenue_type]
}

export const pixelColumnMetricCalculator = (new_campaign_page_feature_flag_active, selectedProductGroup, disp_clicks, disp_leads, disp_calls, disp_generic) => {
    if (new_campaign_page_feature_flag_active) {
        if ([NAME_OF_PRODUCT_TYPES.CLICKS, NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS, NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS].includes(selectedProductGroup)) {
            return disp_clicks
        } else if (selectedProductGroup === NAME_OF_PRODUCT_TYPES.LEADS) {
            return disp_leads
        } else if (selectedProductGroup === NAME_OF_PRODUCT_TYPES.CALLS) {
            return disp_calls
        } else {
            return disp_generic
        }
    } else {
        return disp_generic
    }
}

export const getFilterPackageFilterDescription = (filter) => {

    let filter_value = ""
    switch (filter?.filter_type) {
        case SfFilterTypes.SINGLE_SELECT:
            filter_value = filter?.filter_value
            break;
        case SfFilterTypes.MULTI_SELECT:
            filter_value = JSON.parse(filter?.filter_value || '[]').join(', ')
            break;
        case SfFilterTypes.FREE_FORM:
            filter_value = filter?.filter_value_array?.join(', ')
            break;
        case SfFilterTypes.MIN_MAX:
            switch (filter?.filter_value) {
                case SfFilterRelationalOperators.EQUAL_TO:
                    filter_value = `Equal to ${filter?.filter_value_min || filter?.filter_value_max}`
                    break;
                case SfFilterRelationalOperators.BETWEEN:
                    filter_value = `${filter?.filter_value_min} to ${filter?.filter_value_max}`
                    break;
                case SfFilterRelationalOperators.MORE_THAN:
                    const minValue = Number(filter?.filter_value_min) || 0
                    filter_value = `${minValue + 1} or more`
                    break;
                case SfFilterRelationalOperators.LESS_THAN:
                    const maxValue = Number(filter?.filter_value_max) || 0
                    filter_value = `${maxValue - 1} or less`
                    break;
                default:
                    filter_value = `${filter?.filter_value_min} to ${filter?.filter_value_max}`
            }
        default:
            filter_value
            break;
    }

    if (filter.include) {
        return <span> {filter_value}</span>
    }

    return <span><span>{(filter?.name === 'Age' || filter?.name === 'Coverage Amount') ? 'Is not' : "Doesn't equal"}</span> {" " + filter_value}</span>
}

export const getDecideMayHaveOrMayBe = (word) => {
    const anyWords = ["County", "City", "Zip Code", "Zip Code (Bulk)", "State", "Area Code", "Device Type", "Gender", "Marital Status", "Age", "Education", "Credit Rating", "Household Income", "Coverage Amount", "Coverage Type", "Property Age", "Property Type", "Years in Business", "Type of Coverage", "Vehicle makes", "Vehicle years", "Zip Tiers", "Current Carrier"]

    const mayHaveWords = ["DUI", "Claims", "Dupe days - Calls", "Dupe days - Leads", "Dupe days - Clicks", "Multiple Vehicles", "License Status", "Military Affiliation", "Pre-existing conditions", "Tobacco", "Pre-existing Conditions", "Accidents", "SR-22", "Jornaya Pre-Audit", "Dental-only plans", "Continuous Coverage", "Auto/Home Bundle", "Auto/Renters Bundle", "Home Claims", "Connection Type"]
    const mayBeWords = ["Currently Insured", "Home Owner"]


    if (mayHaveWords.includes(word)) {
        return (`May have ${word}`);
    } else if (anyWords.includes(word)) {
        return (`Any ${word}`);
    } else if (mayBeWords.includes(word)) {
        return (`May be ${word}`);
    } else {
        return (`May be ${word}`);
    }
};

export const getFilterPackagesByProductAndLeadType = (filter_packages, isTargetingPackagesEnabled, campaign_type) => {
    if (isTargetingPackagesEnabled) {
        return [];
    }
    const productTypeId = getProductTypeByName(campaign_type?.product_type)?.id;
    const leadTypeId = getLeadTypeByName(campaign_type?.lead_type)?.id;
    const isExclusive = !(campaign_type?.shared_lead_type);

    const local_filter_packages = filter_packages.filter((f_package) => f_package.product_type_id === productTypeId && f_package.lead_type_id === leadTypeId && f_package.exclusive === isExclusive);

    if (!local_filter_packages.length) {
        return [];
    }

    const filterNames = _.uniqBy(local_filter_packages?.map((f_package, index) => {
        return f_package?.filter_package_filters?.map(filter => filter)
    }).flat(), 'sf_filter_id');

    return local_filter_packages?.map((f_package, index) => {
        return {
            ...f_package,
            filter_package_filters: filterNames.map((filterName, index) => {
                const filter = f_package?.filter_package_filters?.find((eachFilter, index) => {
                    return eachFilter?.sf_filter_id === filterName?.sf_filter_id
                })
                if (filter) {
                    return {
                        ...filter,
                        desc: getFilterPackageFilterDescription(filter),
                        exists: true
                    }
                } else {
                    return {
                        name: filterName?.name,
                        desc: getDecideMayHaveOrMayBe(filterName?.name),
                        exists: false
                    }
                }
            })
        }
    }).sort((a, b) => b?.price - a?.price)
};

export const manageBudgetsAdminPermission = (bsh_isAdminUserDetailsPresent, adminPermissionPresent) => {
    if (bsh_isAdminUserDetailsPresent() && adminPermissionPresent(ADMIN_FEATURE_IDS.MANAGE_BUDGETS)) {
        return true;
    } else {
        return false;
    }
}

export const getSfFilterGroups = (filter_groups, sf_filters, filters_key_name) => {
    return filter_groups?.reduce(
        (acc, group) => {
            const targetfilters = group?.[filters_key_name]?.filter(
                (targetFilter) => sf_filters?.some(
                    (filter) => targetFilter?.sf_filter_id ? targetFilter?.sf_filter_id === filter?.id : true
                )
            )
            return [...acc, {
                ...group,
                [filters_key_name]: targetfilters,
            }]
        }, []
    )
}

export const validateCommaSeperatedEmails = (value) => {
    if (!value || value.trim().length === 0) {
        return "";
    }

    const emails = value.split(",").map((email) => email.trim());
    for (let email of emails) {
        if (invalidEmailRegex.test(email)) {
            return STR_INVALID_EMAIL_DIGITS_ERROR;
        }
        if (!(emailRegex.test(email))) {
            return STR_INVALID_EMAIL;
        }
    }
    return "";
};

export const getCampaignStyles = (isCampaignDiscarded) => {
    return {
        link: isCampaignDiscarded ? {
            style: { 
                pointerEvents: 'none',
                opacity: 0.5,
                cursor: 'not-allowed'
            },
            onClick: (e) => e.preventDefault(),
            title: 'Cannot edit discarded campaign'
        } : {
            style: { 
                pointerEvents: 'auto',
                opacity: 1,
                cursor: 'pointer'
            },
            onClick: undefined,
            title: 'Edit profile'
        },
        toggle: isCampaignDiscarded ? {
            style: { 
                opacity: 0.5,
                cursor: 'not-allowed'
            },
            title: 'Cannot access options for discarded campaign'
        } : {
            style: { 
                opacity: 1,
                cursor: 'pointer'
            },
            title: 'Options'
        },
        textClass: isCampaignDiscarded ? 'text-muted' : null
    };
};

/**
 * Creates pixel-related columns for the campaign table
 * @param {Object} params Configuration parameters
 * @param {Array} params.activeConversionPixels Array of active conversion pixels
 * @param {boolean} params.new_campaign_page_feature_flag_active New campaign page feature flag
 * @param {Object} params.selectedProductGroup Selected product group
 * @param {boolean} params.show_pixel_stats_for_leads_and_calls Show pixel stats flag
 * @param {Object} params.loading Loading states object
 * @param {boolean} params.roas_column_show_ff ROAS column feature flag
 * @returns {Array} Array of column definitions
 */
export const createPixelColumns = ({
  activeConversionPixels,
  new_campaign_page_feature_flag_active,
  selectedProductGroup,
  show_pixel_stats_for_leads_and_calls,
  loading: {
    click_conversion_pixels_aggregated_loading,
    lead_conversion_pixels_agg_loading,
    call_conversion_pixels_agg_loading
  },
  roas_column_show_ff
}) => {
  return activeConversionPixels
    .map(pixel => {
      return [
        {
          dataField: `${pixel.id}:${pixel.name}`,
          columnName: `${pixel.id}:${pixel.name}`,
          isDataFieldName: true,
          text: pixel.name,
          hasDynamicFields: true,
          dynamicTooltipID: `${pixel.id}`,
          tooltipDescription: 'Name of pixel',
          headerFormatter: forColumnHeaderWrapper,
          sort: true,
          hidden: !(pixelColumnMetricCalculator(new_campaign_page_feature_flag_active, selectedProductGroup?.value, pixel?.campaign_pixel_column?.disp_clicks_count,
            pixel?.campaign_pixel_column?.disp_leads_count, pixel?.campaign_pixel_column?.disp_calls_count, pixel?.campaign_pixel_column?.disp_count)),
          pixelColumn: {
            id: pixel.id,
            name: pixelColumnMetricCalculator(new_campaign_page_feature_flag_active, selectedProductGroup?.value, PIXEL_COLUMN_TABLE_FIELDS.DISP_CLICKS_COUNT,
              PIXEL_COLUMN_TABLE_FIELDS.DISP_LEADS_COUNT, PIXEL_COLUMN_TABLE_FIELDS.DISP_CALLS_COUNT, PIXEL_COLUMN_TABLE_FIELDS.DISP_COUNT),
          },
          formatter: (cell, row, _rowIndex, formatExtraData) => formatExtraData?.loading ? (<Skeleton />) : (formatExtraData.show_pixel_stats_for_leads_and_calls || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.CLICKS || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS) ?
            Sfdelimitter(cell || 0) : '--',
          csvFormatter: (cell, row) => (show_pixel_stats_for_leads_and_calls || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.CLICKS || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS) ? SfCommaStringFormatter(cell || 0) : '--',
          formatExtraData: {
            loading: click_conversion_pixels_aggregated_loading || lead_conversion_pixels_agg_loading || call_conversion_pixels_agg_loading,
            show_pixel_stats_for_leads_and_calls: show_pixel_stats_for_leads_and_calls,
          },
          footer: '',
          footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DELIMITTER),
        },
        {
          dataField: `${pixel.id}:${pixel.name} CVR`,
          columnName: `${pixel.id}:${pixel.name} CVR`,
          isDataFieldName: true,
          text: `${pixel.name} CVR`,
          splitHeader: true,
          hasDynamicFields: true,
          dynamicTooltipID: 'campaign-pixel-cvr',
          tooltipDescription: 'Conversion Rate',
          headerFormatter: forColumnHeaderWrapper,
          formatter: (cell, row, _rowIndex, formatExtraData) => formatExtraData?.loading ? (<Skeleton />) : (formatExtraData.show_pixel_stats_for_leads_and_calls || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.CLICKS || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS) ?
            percentFormatWithTwoDecimalPlaces(cell || "0.0") : '--',
          csvFormatter: (_cellContent, row) => (show_pixel_stats_for_leads_and_calls || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.CLICKS || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS) ?
            SfPercentStringFormatter(_cellContent || "0.0") : '--',
          sort: true,
          formatExtraData: {
            loading: click_conversion_pixels_aggregated_loading || lead_conversion_pixels_agg_loading || call_conversion_pixels_agg_loading,
            show_pixel_stats_for_leads_and_calls: show_pixel_stats_for_leads_and_calls,
          },
          sortFunc: sortStringAsFloat,
          hidden: !(pixelColumnMetricCalculator(new_campaign_page_feature_flag_active, selectedProductGroup?.value, pixel?.campaign_pixel_column?.disp_clicks_cvr,
            pixel?.campaign_pixel_column?.disp_leads_cvr, pixel?.campaign_pixel_column?.disp_calls_cvr, pixel?.campaign_pixel_column?.disp_cvr)),
          pixelColumn: {
            id: pixel.id,
            name: pixelColumnMetricCalculator(new_campaign_page_feature_flag_active, selectedProductGroup?.value, PIXEL_COLUMN_TABLE_FIELDS.DISP_CLICKS_CVR,
              PIXEL_COLUMN_TABLE_FIELDS.DISP_LEADS_CVR, PIXEL_COLUMN_TABLE_FIELDS.DISP_CALLS_CVR, PIXEL_COLUMN_TABLE_FIELDS.DISP_CVR),
          },
          footer: '',
          footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.PERCENT_SIGN),
        },
        {
          dataField: `${pixel.id}:${pixel.name} CPA`,
          columnName: `${pixel.id}:${pixel.name} CPA`,
          isDataFieldName: true,
          text: `${pixel.name} CPA`,
          splitHeader: true,
          hasDynamicFields: true,
          dynamicTooltipID: 'campaign-pixel-cpa',
          tooltipDescription: 'Cost per acquisition',
          headerFormatter: forColumnHeaderWrapper,
          formatter: (cell, row, _rowIndex, formatExtraData) => formatExtraData?.loading ? (<Skeleton />) : (formatExtraData.show_pixel_stats_for_leads_and_calls || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.CLICKS || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS) ?
            dollarFormatWithTwoDecimalPlaces(cell || "0.0") : '--',
          formatExtraData: {
            loading: click_conversion_pixels_aggregated_loading || lead_conversion_pixels_agg_loading || call_conversion_pixels_agg_loading,
            show_pixel_stats_for_leads_and_calls: show_pixel_stats_for_leads_and_calls,
          },
          sort: true,
          sortFunc: sortStringAsFloat,
          hidden: !(pixelColumnMetricCalculator(new_campaign_page_feature_flag_active, selectedProductGroup?.value, pixel?.campaign_pixel_column?.disp_clicks_cpa,
            pixel?.campaign_pixel_column?.disp_leads_cpa, pixel?.campaign_pixel_column?.disp_calls_cpa, pixel?.campaign_pixel_column?.disp_cpa)),
          pixelColumn: {
            id: pixel.id,
            name: pixelColumnMetricCalculator(new_campaign_page_feature_flag_active, selectedProductGroup?.value, PIXEL_COLUMN_TABLE_FIELDS.DISP_CLICKS_CPA,
              PIXEL_COLUMN_TABLE_FIELDS.DISP_LEADS_CPA, PIXEL_COLUMN_TABLE_FIELDS.DISP_CALLS_CPA, PIXEL_COLUMN_TABLE_FIELDS.DISP_CPA),
          },
          footer: '',
          footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
        },
        {
          dataField: `${pixel.id}:${pixel.name} Rev`,
          columnName: `${pixel.id}:${pixel.name} Rev`,
          isDataFieldName: true,
          text: `${pixel.name} Rev`,
          splitHeader: true,
          hasDynamicFields: true,
          dynamicTooltipID: 'campaign-pixel-rev',
          tooltipDescription: 'Revenue associated with pixel',
          headerFormatter: forColumnHeaderWrapper,
          formatter: (cell, row, _rowIndex, formatExtraData) => formatExtraData?.loading ? (<Skeleton />) : (formatExtraData.show_pixel_stats_for_leads_and_calls || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.CLICKS || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS) ?
            dollarFormatWithTwoDecimalPlaces(cell || "0.0") : '--',
          formatExtraData: {
            loading: click_conversion_pixels_aggregated_loading || lead_conversion_pixels_agg_loading || call_conversion_pixels_agg_loading,
            show_pixel_stats_for_leads_and_calls: show_pixel_stats_for_leads_and_calls,
          },
          sort: true,
          sortFunc: sortStringAsFloat,
          hidden: !(pixelColumnMetricCalculator(new_campaign_page_feature_flag_active, selectedProductGroup?.value, pixel?.campaign_pixel_column?.disp_clicks_rev,
            pixel?.campaign_pixel_column?.disp_leads_rev, pixel?.campaign_pixel_column?.disp_calls_rev, pixel?.campaign_pixel_column?.disp_rev)),
          pixelColumn: {
            id: pixel.id,
            name: pixelColumnMetricCalculator(new_campaign_page_feature_flag_active, selectedProductGroup?.value, PIXEL_COLUMN_TABLE_FIELDS.DISP_CLICKS_REV,
              PIXEL_COLUMN_TABLE_FIELDS.DISP_LEADS_REV, PIXEL_COLUMN_TABLE_FIELDS.DISP_CALLS_REV, PIXEL_COLUMN_TABLE_FIELDS.DISP_REV),
          },
          footer: '',
          footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent, Formatters.FORMATTER_SIGN.DOLLAR_SIGN),
        },
        {
          dataField: `${pixel.id}:${pixel.name} ROAS`,
          columnName: `${pixel.id}:${pixel.name} ROAS`,
          isDataFieldName: true,
          text: `${pixel.name} ROAS`,
          splitHeader: true,
          hasDynamicFields: true,
          dynamicTooltipID: 'campaign-pixel-roas',
          tooltipDescription: 'Return on Ad Spend',
          headerFormatter: forColumnHeaderWrapper,
          formatter: (cell, row, _rowIndex, formatExtraData) => formatExtraData?.loading ? (<Skeleton />) : (formatExtraData.show_pixel_stats_for_leads_and_calls || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.CLICKS || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS || row?.product_type?.name === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS) ?
            commaFormatWithTwoDecimalPlaces(cell || "0.0") : '--',
          formatExtraData: {
            loading: click_conversion_pixels_aggregated_loading || lead_conversion_pixels_agg_loading || call_conversion_pixels_agg_loading,
            show_pixel_stats_for_leads_and_calls: show_pixel_stats_for_leads_and_calls,
          },
          sort: true,
          sortFunc: sortStringAsFloat,
          hidden: !roas_column_show_ff || !(pixelColumnMetricCalculator(new_campaign_page_feature_flag_active, selectedProductGroup?.value, pixel?.campaign_pixel_column?.disp_clicks_roas,
            pixel?.campaign_pixel_column?.disp_leads_roas, pixel?.campaign_pixel_column?.disp_calls_roas, pixel?.campaign_pixel_column?.disp_roas)),
          pixelColumn: {
            id: pixel.id,
            name: pixelColumnMetricCalculator(new_campaign_page_feature_flag_active, selectedProductGroup?.value, PIXEL_COLUMN_TABLE_FIELDS.DISP_CLICKS_ROAS,
              PIXEL_COLUMN_TABLE_FIELDS.DISP_LEADS_ROAS, PIXEL_COLUMN_TABLE_FIELDS.DISP_CALLS_ROAS, PIXEL_COLUMN_TABLE_FIELDS.DISP_ROAS),
          },
          footer: '',
          footerFormatter: (cellContent) => Formatters.customFooterFormatter(cellContent),
        },
      ]
    })
    .flat();
};

export const getMonthlyBudgetStringForCell = (row) => {
    try {
      return getSummaryStringForMonthlyBudget(row);
    } catch (error) {
      return 'Not Set';
    } {
  
    }
  };

 export const undefinedNullCellFormatter = (cell) => {
    switch (cell) {
      case undefined: return '--';
      case null: return 0;
      default: return cell.toLocaleString();
    }
  }


/**
 * Gets the formatted daily budget string for a campaign, handling any errors
 * @param {Object} campaign The campaign object to get the budget string for
 * @returns {string|React.ReactElement} The formatted budget string or 'Not Set' if there's an error
 */
export const getDailyBudgetStringForCell = (campaign) => {
    try {
      return getSummaryStringForDailyBudget(campaign);
    } catch (error) {
      return 'Not Set';
    } {
        // TODO: Check why do we have this empty.
    }
  };

export const CAMPAIGN_FILTERS = {
    STATUS: 'status',
    PRODUCT: 'product',
    LEAD_TYPE: 'lead_type',
    CAMPAIGN_NAME: 'campaign_name',
    DATE_RANGE: 'date_range',
    BRANDS: 'brands'
  }

export const getSelectBox = ((data, value) => (data.find((item) => item.value === value) || data[0]));

/**
 * Sorts campaigns by their daily budget limits
 * Sorting priority:
 * 1. Budget type (Dollar > Volume > Unlimited > None)
 * 2. Within same type, sort by total budget/volume amount
 * 
 * @param {any} a First row's cell value (unused)
 * @param {any} b Second row's cell value (unused)
 * @param {string} order Sort order ('asc' or 'desc')
 * @param {string} dataField Column field being sorted
 * @param {Object} rowA First complete row data
 * @param {Object} rowB Second complete row data
 * @returns {number} Comparison result (-1, 0, or 1)
 */
export const sortDailyLimit = (a, b, order, dataField, rowA, rowB) => {
  const getBudgetType = (row) => {
    const hasDollarBudget = row?.campaign_budgets.some((element) => element.dollar_budget && !element.volume_budget);
    const hasVolumeBudget = row?.campaign_budgets.some((element) => element.volume_budget && !element.dollar_budget);

    if (hasDollarBudget && hasVolumeBudget) {
      return BUDGETS_TYPES.UNLIMITED;
    } else if (hasDollarBudget) {
      return BUDGETS_TYPES.DOLLAR;
    } else if (hasVolumeBudget) {
      return BUDGETS_TYPES.VOLUME;
    } else {
      return BUDGETS_TYPES.NONE;
    }
  };

  const budgetTypeA = getBudgetType(rowA);
  const budgetTypeB = getBudgetType(rowB);

  // If budget types differ, sort by type
  if (budgetTypeA !== budgetTypeB) {
    return compareBudgetTypes(budgetTypeA, budgetTypeB, order);
  }

  // If same type, sort by total budget/volume
  const getTotalBudget = (row, type) => {
    return row?.campaign_budgets.reduce((sum, element) => {
      if ((type === BUDGETS_TYPES.DOLLAR && element.dollar_budget && !element.volume_budget) ||
        (type === BUDGETS_TYPES.VOLUME && element.volume_budget && !element.dollar_budget)) {
        return sum + parseFloat(type === BUDGETS_TYPES.DOLLAR ? element.dollar_budget : element.volume_budget);
      }
      return sum;
    }, 0);
  };

  const totalA = getTotalBudget(rowA, budgetTypeA);
  const totalB = getTotalBudget(rowB, budgetTypeB);
  return order === ORDER_BY.ASC ? totalA - totalB : totalB - totalA;
};

/**
 * Sorts campaigns by their monthly budget limits
 * Sorting priority:
 * 1. Budget type (Dollar > Volume > Unlimited > None)
 * 2. Within same type, sort by monthly budget/volume amount
 * 
 * @param {any} a First row's cell value (unused)
 * @param {any} b Second row's cell value (unused)
 * @param {string} order Sort order ('asc' or 'desc')
 * @param {string} dataField Column field being sorted
 * @param {Object} rowA First complete row data
 * @param {Object} rowB Second complete row data
 * @returns {number} Comparison result (-1, 0, or 1)
 */
export const sortMonthlyLimit = (a, b, order, dataField, rowA, rowB) => {
  const getBudgetType = (row) => {
    const hasDollarBudget = row?.monthly_budget;
    const hasVolumeBudget = row?.monthly_volume;

    if (hasDollarBudget && !hasVolumeBudget) {
      return BUDGETS_TYPES.DOLLAR;
    } else if (!hasDollarBudget && hasVolumeBudget) {
      return BUDGETS_TYPES.VOLUME;
    } else if (hasDollarBudget && hasVolumeBudget) {
      return BUDGETS_TYPES.UNLIMITED;
    } else {
      return BUDGETS_TYPES.NONE;
    }
  };

  const budgetTypeA = getBudgetType(rowA);
  const budgetTypeB = getBudgetType(rowB);

  // If budget types differ, sort by type
  if (budgetTypeA !== budgetTypeB) {
    return compareBudgetTypes(budgetTypeA, budgetTypeB, order);
  }

  // If same type, sort by total budget/volume
  const getTotalBudget = (row, type) => {
    if (type === BUDGETS_TYPES.DOLLAR) {
      return parseFloat(row?.monthly_budget) || 0;
    } else if (type === BUDGETS_TYPES.VOLUME) {
      return parseFloat(row?.monthly_volume) || 0;
    } else {
      return 0;
    }
  };

  const totalA = getTotalBudget(rowA, budgetTypeA);
  const totalB = getTotalBudget(rowB, budgetTypeB);
  return order === ORDER_BY.ASC ? totalA - totalB : totalB - totalA;
};

export const optionGroupStatus = [
  {
    label: 'Status',
    options: [
      { label: 'All', value: '' },
      { label: 'Active', value: 'Active' },
      { label: 'Paused', value: 'Paused' },
    ],
  },
];

export const optionBulkEdit = [
  {
    options: [
      { label: 'Set Active', value: 'active' },
      { label: 'Set Inactive', value: 'inactive' },
      { label: 'Duplicate', value: 'duplicate' },
      { label: 'Delete', value: 'delete' },

    ],
  },
];
